module.exports = {
      id: "MasterCard-usage",
      viewBox: "0 0 34 24",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#MasterCard-usage",
      toString: function () {
        return this.url;
      }
    }